"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppPromoBanner = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _context = require("../../context");
var _useTranslations = require("../../hooks/useTranslations");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const AppPromoBanner = () => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    appDescription,
    appIcon,
    appName,
    bannerLink,
    className,
    visible,
    onClose
  } = (0, _context.useAppPromo)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onCloseButtonClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    onClose?.();
  }, [onClose]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      className: className,
      "data-testid": getTestId(_constants.APP_PROMO_BANNER),
      href: bannerLink ?? '#',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CloseButton, {
        "data-testid": getTestId(_constants.APP_PROMO_BANNER_CLOSE),
        onClick: onCloseButtonClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.AppInfo, {
        appDescription: appDescription,
        appIcon: appIcon,
        appName: appName
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OpenButton, {
        "data-testid": getTestId(_constants.APP_PROMO_BANNER_OPEN),
        variant: "button",
        children: translations.open
      })]
    })
  });
};
exports.AppPromoBanner = AppPromoBanner;
